
import { defineComponent, ref, onMounted, computed } from "vue";
import { scores, getScores } from "@/store/scores";
import { ISOtoDateGB } from "@/helpers/index";

export default defineComponent({
  name: "Leaderboard",
  props: {
    pageSize: {
      type: Number,
      default: 10,
    },
    controls: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    onMounted(async () => {
      getScores();
    });

    const currentSort = ref<string>("score");
    const currentSortDir = ref<string>("desc");
    const currentPage = ref<number>(1);

    const nextPage = () => {
      if (currentPage.value * props.pageSize < filteredScores.value.length) {
        currentPage.value++;
      }
    };
    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const recentEntriesOnly = ref<boolean>(true);

    const swapFilter = () => {
      recentEntriesOnly.value = !recentEntriesOnly.value;
      currentPage.value = 1;
    };

    const isANextPage = computed((): boolean => {
      return currentPage.value * props.pageSize < filteredScores.value.length;
    });

    const leaderboardDisplay = computed(() => {
      return recentEntriesOnly.value
        ? "newer entries only"
        : "all-time entries";
    });
    const swapButton = computed(() => {
      return !recentEntriesOnly.value
        ? "newer entries only"
        : "all-time entries";
    });

    //filter to newer or alltime
    const filteredScores = computed(() => {
      let array = scores.value;
      if (recentEntriesOnly.value) {
        return (array = array.filter((entry) => entry.date));
      } else {
        return array;
      }
    });

    //sort scores ASC and filter for pagination
    const sortedScores = computed(() => {
      //const array = asArray.value;

      let array = filteredScores.value;

      array = array
        // .sort((a: any, b: any) => {
        //   let modifier = 1;
        //   if (currentSortDir.value === "desc") {
        //     modifier = -1;
        //   }

        //   if (a[currentSort.value] < b[currentSort.value]) {
        //     return -1 * modifier;
        //   }
        //   if (a[currentSort.value] > b[currentSort.value]) {
        //     return 1 * modifier;
        //   }
        //   return 0;
        // })
        .sort(function(a: any, b: any) {
          return b.score - a.score;
        })
        .filter((row: any, index: number) => {
          const start = (currentPage.value - 1) * props.pageSize;
          const end = currentPage.value * props.pageSize;

          if (index >= start && index < end) {
            return true;
          }
        });

      return array;
    });

    return {
      nextPage,
      prevPage,
      currentSort,
      currentSortDir,
      sortedScores,
      currentPage,
      scores,
      filteredScores,
      isANextPage,
      leaderboardDisplay,
      recentEntriesOnly,
      swapFilter,
      swapButton,
      ISOtoDateGB,
    };
  },
});
